import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useRoutes,
  Navigate,
  Redirect,
} from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./components/Auth/Auth";
import Signin from "./components/Auth/Signin";
import Signup from "./components/Auth/Signup";
import Clubs from "./pages/Clubs";
import LandingPage from "./pages/LandingPage";
import { ThemeProvider } from '@mui/material/styles';
import Profile from "./pages/Profile";
import SmoothScroll from "smooth-scroll";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./pages/ErrorFallback";
import theme from './theme';
import { getUserData } from "./components/Helper";
import ProtectedRoutesComponent from "./components/commonComponents/ProtectedRoutesComponent";
import Layout from "./components/commonComponents/Layout";
import Topics from "./pages/Topics";
import Project from "./pages/Project";
import Submissions from "./pages/Submissions";
import Monitor from "./pages/Monitor.jsx";
import ClubForm from "./pages/ClubForm.jsx";
// import { ClubDetails } from "./components/clubs/clubsColdStart/ClubDetails";
import MemberClubDetails from "./pages/MemberClubDetails";
import AuthWrapper from "./components/AuthWrapper.js";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const profile = JSON.parse(localStorage.getItem('profile'));
  const profpath = profile?.response?.user?.meta?.og_url
  console.log("profpath", profpath)

  // const profile = JSON.parse(localStorage.getItem('profile'));
  // const profpath = profile?.response?.user?.meta?.og_url || "/account";
  // console.log("profpath", profpath)



  return (
    <AuthProvider>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <Routes>
              <Route path="/signin" element={<Signin />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/" element={<LandingPage />} />
              <Route
                element={<ProtectedRoutesComponent />}
              >
                <Route element={<Layout />}>
                  <Route exact path='/account' element={<Profile />}></Route>
                  <Route exact path='/clubs' element={<Clubs />}></Route>
                  <Route exact path="/club-topics/:category" element={<Topics />}></Route>
                  <Route exact path="/project/:projectId" element={<Project />}></Route>
                  <Route exact path="/create-club" element={<ClubForm />}></Route>
                  <Route exact path="/club/:clubId" element={<MemberClubDetails />}></Route>
                  <Route exact path="/club/:clubId/project/:projectId" element={<Project />}></Route>
                  <Route exact path="/dashboard" element={<Submissions />}></Route>
                  <Route exact path="/monitor" element={<Monitor />}></Route>
                  <Route path="*" element={<Navigate to="/clubs" replace />} />
                </Route>
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ThemeProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </AuthProvider>
  );
};

export default App;
